import { inject, Injectable } from '@angular/core';
import { SettingsService } from '@app/core/settings/settings.service';
import { MemberService } from '@app/core/members/member.service';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SchemaConsents } from '@app/core/_models/schema/schema-consents';
import { MissingPropertiesService } from '@app/core/missing-properties.service';
import { MemberInterface } from '@app/core/_models/member-interface';

@Injectable()
export class ForceUpdateService {
  private settingsService = inject(SettingsService);
  private missingPropertiesService = inject(MissingPropertiesService);
  private memberService = inject(MemberService);


  public requireForcePropertiesUpdate$(): Observable<boolean> {
    return this.missingPropertiesService.getMissingPropertyNames().pipe(
      map((missingProperties) =>
        this.settingsService.settings.forced_profile_update && !!missingProperties.length,
      ),
    );
  }

  public requireForceConsentUpdate$(): Observable<boolean> {
    return this.memberService.get().pipe(
      filter(Boolean),
      map((member: Partial<MemberInterface>) => {
        const count = this.requiredConsentsCount;

        return !member.consents || Object.keys(member.consents).length < count;
      }),
    );
  }

  private get requiredConsentsCount(): number {
    const settings = this.settingsService.settings;

    return settings.schema.consents
      ? this.totalRequiredConsentsCount(settings.schemaObject.consents)
      : 0;
  }

  private totalRequiredConsentsCount(consents: SchemaConsents): number {
    return consents.availableConsentsKeys().filter((key) => consents.isRequired(key)).length;
  }
}
